/**
 * Парсит "Фамилия Имя Отчество" из одной строки в три поля.
 * Логика повторяет серверную миграцию.
 */
export function splitFullName(full) {
  if (!full || typeof full !== 'string') {
    return { last_name: '', name: '', patronymic: '' };
  }
  const parts = full.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return { last_name: '', name: '', patronymic: '' };
  if (parts.length === 1) return { last_name: '', name: parts[0], patronymic: '' };
  if (parts.length === 2) return { last_name: parts[0], name: parts[1], patronymic: '' };
  return {
    last_name: parts[0],
    name: parts[1],
    patronymic: parts.slice(2).join(' '),
  };
}

/**
 * Собирает три поля в "Фамилия Имя Отчество".
 */
export function joinFullName({ last_name = '', name = '', patronymic = '' } = {}) {
  return [last_name, name, patronymic]
    .map(s => (s || '').trim())
    .filter(Boolean)
    .join(' ');
}

/**
 * Достаёт имя клиента для отображения. Сначала пробует новые поля,
 * иначе fallback на full_name (для старых аккаунтов).
 */
export function getDisplayName(obj) {
  if (!obj) return '';
  const joined = joinFullName(obj);
  return joined || obj.full_name || '';
}

/**
 * Первое имя — для приветствий ("Здравствуйте, Алексей!")
 */
export function getFirstName(obj) {
  if (!obj) return '';
  if (obj.name && obj.name.trim()) return obj.name.trim();
  if (obj.full_name) return obj.full_name.split(/\s+/)[0] || '';
  return '';
}